import { render, staticRenderFns } from "./ViaggiTrenoPartenze.vue?vue&type=template&id=2e2ee947"
import script from "./ViaggiTrenoPartenze.vue?vue&type=script&lang=js"
export * from "./ViaggiTrenoPartenze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports